import { doDrawImage } from "./doDrawImage";

export function doDrawImage3(ctx, src, dstLeft, dstTop, destWidth, destHeight) {
  ctx.imageSmoothingEnabled = true;
  ctx.drawImage(src, dstLeft, dstTop, destWidth, destHeight);
}
